import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { returnPathFromLocation } from '../auth/returnPath';
import './AuthStatusPage.scss';

// /login from the cutoff on (ENTRA_MIGRATION=cutoff or closed;
// docs/EntraFullMigrationPlan.md §3.2): no email and password, only the way to
// Microsoft. Existing users sign up there again with the same email and are
// linked to their account; new users take the same button and then onboarding.
export default function CutoffLogin() {
  const { loginWithEntra, authError } = useContext(UserContext);
  const location = useLocation();
  // The page that sent the user here (ProtectedRoute, RootRedirect): both ways
  // to Microsoft come back to it after the callback.
  const returnTo = returnPathFromLocation(location.state?.from);
  const [error, setError] = useState('');
  const [isLeaving, setIsLeaving] = useState(false);

  // "כניסה ראשונה" opens Microsoft's sign-up page (prompt: 'create'), "כבר
  // עברתי" its sign-in page.
  const goToMicrosoft = async ({ prompt = null, failure }) => {
    setIsLeaving(true);
    setError('');
    try {
      await loginWithEntra({ intent: 'login', prompt, returnTo });
    } catch (startError) {
      console.error('Opening Microsoft sign-in failed:', startError);
      setError(failure);
      setIsLeaving(false);
    }
  };
  const firstSignIn = () => goToMicrosoft({ prompt: 'create', failure: 'לא הצלחנו לפתוח את דף ההרשמה. נסו שוב.' });
  const alreadyMoved = () => goToMicrosoft({ failure: 'לא הצלחנו לפתוח את דף ההתחברות. נסו שוב.' });

  return (
    <div className="auth-status-page cutoff-login" dir="rtl">
      <h1>כניסה ל mashlom.me</h1>
      <p>כחלק משיפורי אבטחה, משלום עברה לכניסה מאובטחת חדשה.</p>
      <p>
        אם יש לכם כבר חשבון במשלום, ולא עברתם למערכת החדשה - לחצו על &quot;כניסה ראשונה למערכת החדשה&quot;
        והירשמו עם אותה כתובת מייל שבה השתמשתם במשלום. תוך כדי התהליך, אתם תקבלו קוד לאימייל כדי לוודא
        אותו ותבחרו סיסמה חדשה. החשבון, ההרשאות והמחלקות שלכם יישמרו גם אחרי ההרשמה המחודשת.
      </p>
      <p>אם כבר עברתם לכניסה המאובטחת החדשה, לחצו על &quot;כבר עברתי – כניסה&quot;.</p>
      {(error || authError) && <p role="alert" style={{ color: '#B42318' }}>{error || authError}</p>}
      <button type="button" className="auth-status-primary" onClick={firstSignIn} disabled={isLeaving}>
        {isLeaving ? 'מעביר...' : 'כניסה ראשונה למערכת החדשה'}
      </button>
      <button type="button" className="auth-status-secondary" onClick={alreadyMoved} disabled={isLeaving}>
        כבר עברתי – כניסה
      </button>
      <p style={{ fontSize: '0.9rem' }}>
        אם מופיעה רשימת חשבונות של אחרים, בחרו &quot;השתמש בחשבון אחר&quot;.
      </p>
    </div>
  );
}
